import moment from 'moment';

export function utcToLocalFormat(value, format) {
  if (!value) {
    return '';
  }

  var defaultFormat = 'MMM, DD hh:mm:ss A';
  if (format && format != '') {
    defaultFormat = format;
  }
  return moment.utc(String(value)).local().format(defaultFormat);
}